export { default } from './comments-2'
